const RELOAD_FLAG_KEY = 'chunk-reload-attempted';

async function purgeServiceWorkerAndCaches() {
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();

      await Promise.all(registrations.map((r) => r.unregister()));
    }
  } catch {}

  try {
    if ('caches' in window) {
      const keys = await caches.keys();

      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {}
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:chunkError', async () => {
    try {
      if (sessionStorage.getItem(RELOAD_FLAG_KEY)) return;
      sessionStorage.setItem(RELOAD_FLAG_KEY, '1');
    } catch {}

    await purgeServiceWorkerAndCaches();

    window.location.reload();
  });

  nuxtApp.hook('app:mounted', () => {
    try {
      sessionStorage.removeItem(RELOAD_FLAG_KEY);
    } catch {}
  });
});
